import { Check } from "lucide-react";
import { STEPS, orderMode, stepIndex, fmtDT } from "./orderMeta";

export function OrderTimeline({ o }) {
  const steps = STEPS[orderMode(o)];
  const idx = stepIndex(o);
  const hist = Array.isArray(o.history) ? o.history : [];
  const when = (s) => { const h = [...hist].reverse().find((x) => x?.status === s); return h?.at ? fmtDT(h.at) : null; };
  if (idx < 0) return <p data-testid={`order-timeline-${o.order_number}`} className="text-[11px] text-zinc-500 mt-2">Encomenda {o.status === "refunded" ? "reembolsada" : "cancelada"}.</p>;
  return (
    <ol data-testid={`order-timeline-${o.order_number}`} className="mt-2 grid grid-cols-4 gap-1">
      {steps.map(([s, label], i) => {
        const done = i <= idx;
        return (
          <li key={s} className="text-center">
            <div className={`mx-auto w-5 h-5 rounded-full flex items-center justify-center text-[10px] ${done ? "bg-black text-white" : "bg-zinc-100 text-zinc-400 border border-zinc-200"}`}>{done ? <Check size={11} /> : i + 1}</div>
            <div className={`text-[10px] mt-1 leading-tight ${done ? "font-semibold text-black" : "text-zinc-400"}`}>{label}</div>
            {done && when(s) && <div className="text-[9px] text-zinc-400">{when(s)}</div>}
          </li>
        );
      })}
    </ol>
  );
}

export function ShipmentHistory({ o, testid }) {
  const rows = (o.shipment?.history || []).slice().reverse();
  if (!rows.length) return null;
  return (
    <details data-testid={testid || `shipment-history-${o.order_number}`} className="mt-2 text-[11px]">
      <summary className="cursor-pointer text-zinc-500">Histórico do envio ({rows.length})</summary>
      <ul className="mt-1 space-y-1">
        {rows.map((h, i) => (
          <li key={i} className="text-zinc-600">
            <span className="text-zinc-400">{fmtDT(h.at)}</span> · {h.carrier_name || h.carrier}{h.tracking_number ? ` · nº ${h.tracking_number}` : ""}{h.by_role === "admin" ? " · admin" : ""}{h.note ? ` — ${h.note}` : ""}
          </li>
        ))}
      </ul>
    </details>
  );
}
